import {
    ContextualMenu, getId, Icon, IContextualMenuProps,
    IDragOptions, Modal, TextField, Link
} from "@fluentui/react";
import { textFieldStyles } from "../../common/views/DefaultStyles";
import { StyleUtils } from "../../common/views/StyleUtils";
import { Utils } from "../../common/views/Utils";
import { IPictureService } from "../../pictures/viewmodels/PictureVM";
import ManagePictureView from "../../pictures/views/ManagerPictureView";
import { NewFeedModel } from "../models/NewFeedModel";

type NewFeedDetailProps = {
    feed?: NewFeedModel;
    pictureService: IPictureService;
    onEdit: (feed: NewFeedModel) => void;
    onClose: (refresh: boolean) => void;
}

export default function NewFeedDetailView({
    feed, pictureService, onClose, onEdit
}: NewFeedDetailProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const dragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };
    const commandMenuProps: IContextualMenuProps = {
        shouldFocusOnMount: true,
        items: []
    };

    const width2 = Utils.getColumnWidth(2);
    const width6 = Utils.getColumnWidth(6, 12, 12);
    const width10 = Utils.getColumnWidth(10);

    const modalHeader = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>New Feed Details</b></div>
                <div className={width2 + " right"}>
                    <Icon
                        iconName="ChromeClose"
                        className="pointer"
                        onClick={() => onClose(false)}
                    />
                </div>
            </div>
        </div>;
    }

    const infoView = () => {
        if (!feed) {
            return <></>;
        }

        const now = new Date();
        const start = new Date(feed.start);
        const end = new Date(feed.end);
        const validDate = start <= now && now <= end;
        const strStart = Utils.formatShortDate(start);
        const strEnd = Utils.formatShortDate(end);

        const brandInput = () => {
            return <>
                <TextField
                    label="Brand"
                    value={feed.brand}
                    readOnly={true}
                    styles={textFieldStyles}
                />
            </>;
        }

        const titleInput = () => {
            return <>
                <TextField
                    label="Title"
                    value={feed.title}
                    readOnly={true}
                    multiline={true}
                    rows={2}
                    styles={textFieldStyles}
                />
            </>;
        }

        const descriptionInput = () => {
            return <>
                <TextField
                    label="Description"
                    value={feed.description}
                    readOnly={true}
                    multiline={true}
                    rows={2}
                    styles={textFieldStyles}
                />
            </>;
        }

        return <>
            <div>{brandInput()}</div>
            <div className="pt-10">{titleInput()}</div>
            <div className="pt-10">{descriptionInput()}</div>

            <div className="pt-10 container">
                <span>Valid Date: {strStart} - {strEnd}</span>
                <Icon
                    iconName={validDate ? "CompletedSolid" : "StatusErrorFull"}
                    className={(validDate ? "accepted" : "firmed") + " pl-10"}
                />
            </div>
            <div className="p">
                Activated: {feed.active ? "Yes" : "No"}
            </div>

            <div className="pt-10">
                <Link onClick={() => onEdit(feed)}>Edit</Link>
            </div>
        </>;
    }

    return <>
        <Modal
            titleAriaId={titleId}
            subtitleAriaId={subtitleId}
            isOpen={true}
            onDismiss={() => onClose(false)}
            isBlocking={true}
            isModeless={false}
            styles={StyleUtils.getModalWidthStyles(800)}
        >
            <div className="popup popup-header">
                {modalHeader()}
            </div>

            <div id={subtitleId} className="popup-body ms-Grid">
                <div className="ms-Grid-row ph-10 pt-10 pb-20">
                    <div className={width6}>{infoView()}</div>
                    <div className={width6 + " pt-5 center"}>
                        <ManagePictureView
                            ownerId={feed?.id}
                            service={pictureService}
                            isReadonly={false}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    </>;
}